import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DescriptionList = _resolveComponent("DescriptionList")!
  const _component_DifferentLenderButton = _resolveComponent("DifferentLenderButton")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "grid grid-cols-2 md:grid-cols-3 gap-6 items-center justify-between p-4 md:p-6" }, {
    default: _withCtx(() => [
      _createVNode(_component_DescriptionList, { label: "Loan Amount" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.formatCurrency(_ctx.loanAmount.amount, _ctx.loanAmount.currency)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_DescriptionList, {
        label: "Base Interest Rate",
        class: "md:mx-auto"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.baseInterestRate) + "% ", 1)
        ]),
        _: 1
      }),
      _createVNode(_component_DifferentLenderButton, {
        class: "col-span-2 md:col-span-1 mx-auto md:mr-0",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('differentLender')))
      })
    ]),
    _: 1
  }))
}